<template>
  <div>
    <v-container>
      <v-row>
        <v-col
          cols="12"
          md="3"
          v-for="(boolKey, index) in booleansKeys"
          :key="index"
        >
          <v-switch
            @change="handleUpdate(boolKey)"
            :label="$t(`labels.${boolKey}`)"
            v-model="booleanObject[boolKey]"
          ></v-switch>
        </v-col>
        <v-row>
          <template v-for="(fileKey, index) in Object.keys(filesData)">
            <v-col
              cols="12"
              md="6"
              :key="index"
              v-if="filesData[fileKey]&&available_images.includes(fileKey)"
            >
              <strong class="mb-5">{{ $t(`labels.${fileKey}`) }}</strong>
              <new-image-upload
               reqType="page-settings"
                class="file-upload__image"
                :file_name="fileKey"
                :imgUrl="filesData[fileKey] && filesData[fileKey].path"
                :imgId="filesData[fileKey] && filesData[fileKey].id"
                :maxSize="maxsize"
              />
            </v-col>
            <!-- <v-col
              class="mb-3"
              cols="12"
              md="6"
              :key="index"
              v-if="filesData[fileKey]&&single_files.includes(fileKey)"
            >
              <strong class="mb-5">{{ $t(`labels.${fileKey}`) }}</strong>

              <fileUpload
              reqType="page-settings"
                :locale="locale"
                :file_url="filesData[fileKey]"
                :file_id="filesData[fileKey]&&filesData[fileKey].id"
                class="file-upload__image"
                :maxSize="maxsize"
                :file_name="fileKey"
                
                
              />
            </v-col> -->
            <!-- <v-col
               v-if="filesData[fileKey]&&multi_files.includes(fileKey)"
              cols="12"
              md="6"
              :key="index"
            >
              <strong class="mb-5">{{ $t(`labels.${fileKey}`) }}</strong>
              <fileUpload
              :file_id="filesData[fileKey]&&filesData[fileKey].id"
               reqType="page-settings"
                :locale="locale"
                :files_urls="filesData[fileKey]"
                class="file-upload__image"
                :maxSize="maxsize"
                :file_name="fileKey"
                :multiple="true"
              />
            </v-col> -->
          </template>
        </v-row>
      
        <v-col cols="12" class="mt-5">
          <v-row style="margin-top:50px">
            <template v-for="(value, fieldName) in form">
              <v-col
                v-if="
                  !fieldName.includes('phone') && !fieldName.includes('email')
                "
                cols="12"
                :key="fieldName"
              >
                <Editor :locale="locale" :form="form" :fieldName="fieldName" />
              </v-col>
              <v-col :key="fieldName" v-else>
                <form-group
                  :validator="$v.form[fieldName]"
                  :name="fieldName"
                  :attribute="`labels.${fieldName}`"
                >
                  <template slot-scope="{ attrs, listeners }">
                    <v-text-field
                      v-on="listeners"
                      :type="fieldName.includes('phone') ? 'number' : 'email'"
                      v-model="form[fieldName]"
                      v-bind="attrs"
                    ></v-text-field>
                  </template>
                </form-group>
                <v-btn
                  @click.prevent="handleSubmit(fieldName)"
                  class="primary"
                  :disabled="$v.form[fieldName].$invalid"
                  type="submit"
                  >{{ $t("button.save") }}</v-btn
                >
              </v-col>
            </template>
          </v-row>
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>

<script>
import { StoreData } from "@/helpers/apiMethods";
import { email } from "vuelidate/lib/validators";
import { validPhoneNumber } from "@/utils/validate";
export default {
  name: "Informations",
  components: {
    Editor: () => import("@/components/Editor"),
    fileUpload: () => import("@/components/fileUpload")
  },
  props: {
    form: {
      type: Object,
      default: () => {}
    },
    locale: {
      type: String,
      default: ""
    },
    booleanObject: {
      type: Object,
      default: () => {}
    },
    filesData: {
      type: Object,
      default: () => {}
    }
  },
  data() {
    return {
      maxsize: 2045,
      // single_files:['model_data'],
      // multi_files:['policies_list_of_files','regulations_list_of_files'],
      available_images:['external_board_image','registration_certificate_image'],
    };
  },

  computed: {
    booleansKeys() {
      return Object.keys(this.booleanObject);
    }
  },

  methods: {
    handleSubmit(fieldName) {
      const reqData = {
        [fieldName]: this.form[fieldName],
        locale: this.locale,
        page_name: this.$route.name
      };
      StoreData({ reqName: "page-settings", data: reqData });
    },
    handleUpdate(key) {
      const reqData = {
        [key]: this.booleanObject[key],
        locale: this.locale,
        page_name: this.$route.name
      };
      this.popUp().then(value => {
        if (!value.dismiss) {
          StoreData({
            reqName: "page-settings",
            data: reqData
          });
        } else {
          this.booleanObject[key] = !this.booleanObject[key];
        }
      });
    }
  },
  validations: {
    form: {
      representative_email: {
        email
      },
      representative_phone: {
        validPhoneNumber
      }
    }
  }
};
</script>

